import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaBlock } from '../CtaBlock';
import { volumes } from '../../data/content';
export function VolumesSection() {
  return <section className="bg-white py-14 sm:py-20" aria-labelledby="volumes-title" data-id="element-334" data-mp="2mu3qik4o5iv4">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-335" data-mp="2rt6xwb84g169">
        <SectionHeading eyebrow="Here is everything you get today" title={<span id="volumes-title" data-id="element-337" data-mp="2e0ie37fz8dov">The Clinical Decision System for Diabetes</span>} subtitle="You’re not buying a manual. You’re adding a decision-making system to your clinical practice — designed to help you make better decisions, reduce uncertainty, and save time with every patient." data-id="element-336" data-mp="2e2ldgi30rj69" />

        <h3 className="mx-auto mt-12 max-w-2xl text-center text-lg font-black leading-tight tracking-tight text-navy-900 sm:text-2xl" data-id="element-338" data-mp="2915owg1muuj4">
          The 6 volumes of the Clinical Decision System for Diabetes
        </h3>
        <p className="mx-auto mt-3 max-w-xl text-center text-sm text-navy-600 sm:text-base" data-id="element-339" data-mp="1fj0a6gflkw82">
          Each volume solves a specific stage of diabetes management, so you always know what the
          next step is.
        </p>

        <div className="mt-8 space-y-5" data-id="element-340" data-mp="1pgenw8a4z6wo">
          {volumes.map(volume => <article key={volume.number} className="overflow-hidden rounded-3xl border border-navy-100 bg-white shadow-[0_2px_12px_rgba(6,18,37,0.06)]" data-id="element-341" data-mp="1khtpmeeg2xav">
              <div className={`flex items-center gap-3 px-4 py-3 sm:px-6 ${volume.accent}`} data-id="element-342" data-mp="ru7ln51b1qnh">
                <span className="rounded-md bg-white/20 px-2 py-1 text-[10px] font-black uppercase tracking-widest text-white" data-id="element-343" data-mp="16ibw5lq7evv6">
                  Volume {volume.number}
                </span>
                <h4 className="text-balance text-[15px] font-black leading-tight text-white sm:text-lg" data-id="element-344" data-mp="e2at4zvq5eqk">
                  {volume.title}
                </h4>
              </div>
              <div className="p-4 sm:p-6" data-id="element-345" data-mp="913ld0tl0fjw">
                <p className="text-pretty text-[14px] leading-relaxed text-navy-700 sm:text-base" data-id="element-346" data-mp="ys52pxqov4re">
                  {volume.promise}
                </p>
                <p className="mt-5 text-[10px] font-black uppercase tracking-[0.14em] text-clinic-700 sm:text-[11px]" data-id="element-347" data-mp="12qufbo3wki9z">
                  {volume.outcomesLabel}
                </p>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-348" data-mp="1ci8etvvuti34">
                  {volume.outcomes.map(outcome => <li key={outcome} className="flex items-start gap-2.5" data-id="element-349" data-mp="fuu2oax8g7aw">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-clinic-600" aria-hidden="true" data-id="element-350" data-mp="jucora0siofb" />
                      <span className="text-[13.5px] font-medium leading-snug text-navy-800 sm:text-[15px]" data-id="element-351" data-mp="ttaciaqe6dx9">
                        {outcome}
                      </span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <CtaBlock kicker="Six stages of diabetes management — organized from start to finish." label="👉 I want all 6 volumes now" data-id="element-352" data-mp="3po53j2a50mub" />
      </div>
    </section>;
}